
import Auth from "./auth";
import MagicLink from "./magic-link";
import Error from "./error";

export const AuthPage = Auth;
export const MagicLinkPage = MagicLink;
export const ErrorPage = Error;